import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { FadeView, TextLink, theme } from '@sg/garnish';

import { OrderPlaybackCta } from './OrderPlaybackCta';

export const OrderPlaybackFooter = (props: OrderPlaybackFooterProps) => {
  const {
    fadeIn,
    animationDuration,
    isLoading,
    isPostOrder,
    goBack,
    confirmOrder,
  } = props;

  return (
    <View style={styles.container}>
      <FadeView keepMounted show={!isLoading && !isPostOrder}>
        <TextLink
          underline={false}
          sizeMatch={['18']}
          style={styles.goBack}
          onPress={goBack}
        >
          <FormattedMessage {...messages.goBack} />
        </TextLink>
      </FadeView>

      <OrderPlaybackCta
        isPostOrder={isPostOrder}
        isLoading={isLoading}
        onPress={confirmOrder}
        fadeIn={fadeIn}
        animationDuration={animationDuration}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  goBack: {
    defaultMessage: 'Go back',
    description: 'Bag | Order playback | Go back',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    marginTop: -theme.spacing['4'],
    gap: theme.spacing['4'],
  },
  goBack: {
    minWidth: 120,
    textAlign: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    padding: theme.spacing['2'],
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackFooterProps = {
  fadeIn: number;
  animationDuration: number;
  isPostOrder: boolean;
  isLoading: boolean;
  goBack: () => void;
  confirmOrder: () => void;
};
